var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageStatusNotreceive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Message Status"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.6,
    d: "M9.83527 0.736018L9.04688 0L5.50194 3.30947L6.29032 4.04549L9.83527 0.736018ZM12.206 0L6.29032 5.52274L3.95312 3.34601L3.16473 4.08203L6.29032 7L13 0.736018L12.206 0ZM0 4.08203L3.12559 7L3.91398 6.26398L0.793979 3.34601L0 4.08203Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageStatusNotreceive);
export default __webpack_public_path__ + "static/media/message-status-notreceive.00299724bf28fc364f4f8657f3b7c7f1.svg";
export { ForwardRef as ReactComponent };